import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M13 8.25a3.25 3.25 0 0 0 0-6.5m.25 10h.125a4.875 4.875 0 0 1 4.875 4.875c0 .898-.727 1.625-1.625 1.625H15M10.25 5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM3.375 18.25h7.25c.898 0 1.625-.727 1.625-1.625a4.875 4.875 0 0 0-4.875-4.875h-.75a4.875 4.875 0 0 0-4.875 4.875c0 .898.728 1.625 1.625 1.625Z"
	})]
});
const ForwardRef = forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
